<template>
  <v-container>
    <v-card>
      <v-card-text style="padding:0px;">
        <template>
          <v-toolbar color="primary" light>
            <v-toolbar-title class="white--text"
              >Payment Config</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
              <v-btn color="primary" flat @click="dialog = true">Add New</v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </template>
        <div>
          <v-toolbar flat color="white" dense style="margin-bottom:0px">
            <v-btn color="success" small @click="loadConfig()"
              ><v-icon>mdi-refresh</v-icon> Refresh</v-btn
            >
            <v-btn
              color="danger"
              class="white--text"
              small
              @click="deleteConfig()"
              :disabled="!selected.length > 0"
              ><v-icon>mdi-delete</v-icon> Delete</v-btn
            >
            <v-btn
              color="primary"
              small
              @click="editConfig()"
              :disabled="!(selected.length == 1)"
              ><v-icon>mdi-lead-pencil</v-icon> Edit</v-btn
            >
            <v-spacer></v-spacer>
            <div style="width:200px;">
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </div>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="vendors"
            v-model="selected"
            :search="search"
            :loading="true"
            item-key="id"
            dense
            select-all
            class="elevation-1"
          >
            <v-progress-linear
              slot="progress"
              color="blue"
              indeterminate
            ></v-progress-linear>
            <template slot="headerCell" slot-scope="{ header }">
              <div
                class="subheading font-weight-light text-primary text--darken-3"
                v-text="header.text"
              ></div>
              <div
                class="font-weight-light text--darken-4"
                v-text="header.desc"
              ></div>
            </template>

            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  v-model="props.selected"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </td>
              <td>
                {{ props.index }}
              </td>
              <td>{{ vendorName(props.item.vendor_id) }}</td>
              <td class="text-xs-center text-no-wrap">
                <v-select
                  v-model="props.item.gateway"
                  :items="['razorpay', 'paytm']"
                  @change="update(props.item)"
                  label="Gateway"
                >
                </v-select>
              </td>
              <td>{{ props.item.rzp_account_id }}</td>
              <td>{{ props.item.rzp_key }}</td>
              <td>{{ props.item.rzp_secret }}</td>
              <td>{{ props.item.paytm_mid }}</td>
              <td>{{ props.item.paytm_key }}</td>
              <td>
                <v-switch
                  v-model="props.item.testing"
                  color="primary"
                  class="v-input--reverse"
                  style="justify-content:start;"
                  hide-details
                  readonly
                >
                  <template slot="label">
                    Testing
                  </template>
                </v-switch>
              </td>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">New Config</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-select
                    :items="$store.state.vendors"
                    item-text="app_name"
                    item-value="id"
                    label="Select Vendor"
                    v-model="config.vendor_id"
                    single-line
                    hide-details
                    color="primary"
                    :rules="rules.required"
                  ></v-select>
                  <v-select
                    v-model="config.gateway"
                    :items="['razorpay', 'paytm']"
                    color="primary"
                    label="Gateway"
                    :rules="rules.required"
                  >
                  </v-select>
                  <v-text-field
                    v-if="config.gateway == 'razorpay'"
                    label="Razorpay Merchant Account Id*"
                    :rules="
                      config.rzp_key !== '' || config.rzp_secret !== ''
                        ? []
                        : rules.required
                    "
                    v-model="config.rzp_account_id"
                    :disabled="
                      config.rzp_key !== '' || config.rzp_secret !== ''
                    "
                  ></v-text-field>
                  <v-text-field
                    v-if="config.gateway == 'razorpay'"
                    label="Razorpay Merchant Key*"
                    :rules="config.rzp_account_id !== '' ? [] : rules.required"
                    v-model="config.rzp_key"
                    :disabled="config.rzp_account_id !== ''"
                  ></v-text-field>
                  <v-text-field
                    v-if="config.gateway == 'razorpay'"
                    label="Razorpay Merchant Secret*"
                    :rules="config.rzp_account_id !== '' ? [] : rules.required"
                    v-model="config.rzp_secret"
                    :disabled="config.rzp_account_id !== ''"
                  ></v-text-field>
                  <v-text-field
                    v-if="config.gateway == 'paytm'"
                    label="Paytm Mid*"
                    :rules="rules.required"
                    v-model="config.paytm_mid"
                  ></v-text-field>
                  <v-text-field
                    v-if="config.gateway == 'paytm'"
                    label="Paytm Key*"
                    :rules="rules.required"
                    v-model="config.paytm_key"
                  ></v-text-field>
                  <v-switch
                    v-model="config.testing"
                    color="primary"
                    class="v-input--reverse"
                    style="justify-content:start;"
                    hide-details
                  >
                    <template slot="label">
                      Testing
                    </template>
                  </v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            small
            outline
            @click.native="
              dialog = false;
              resetForm();
            "
            >Close</v-btn
          >
          <v-btn
            color="primary darken-1 white--text"
            small
            :disabled="!valid"
            @click.native="addConfig()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog1" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Update Config</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid1">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-select
                    :items="$store.state.vendors"
                    item-text="app_name"
                    item-value="id"
                    label="Select Vendor"
                    v-model="config.vendor_id"
                    single-line
                    hide-details
                    color="primary"
                    :rules="rules.required"
                  ></v-select>
                  <v-select
                    v-model="config.gateway"
                    :items="['razorpay', 'paytm']"
                    color="primary"
                    label="Gateway"
                    :rules="rules.required"
                  >
                  </v-select>
                  <v-text-field
                    v-if="config.gateway == 'razorpay'"
                    label="Razorpay Merchant Account Id*"
                    :rules="
                      config.rzp_key !== '' || config.rzp_secret !== ''
                        ? []
                        : rules.required
                    "
                    v-model="config.rzp_account_id"
                    :disabled="
                      config.rzp_key !== '' || config.rzp_secret !== ''
                    "
                  ></v-text-field>
                  <v-text-field
                    v-if="config.gateway == 'razorpay'"
                    label="Razorpay Merchant Key*"
                    :rules="config.rzp_account_id !== '' ? [] : rules.required"
                    v-model="config.rzp_key"
                    :disabled="config.rzp_account_id !== ''"
                  ></v-text-field>
                  <v-text-field
                    v-if="config.gateway == 'razorpay'"
                    label="Razorpay Merchant Secret*"
                    :rules="config.rzp_account_id !== '' ? [] : rules.required"
                    v-model="config.rzp_secret"
                    :disabled="config.rzp_account_id !== ''"
                  ></v-text-field>
                  <v-text-field
                    v-if="config.gateway == 'paytm'"
                    label="Paytm Mid*"
                    :rules="rules.required"
                    v-model="config.paytm_mid"
                  ></v-text-field>
                  <v-text-field
                    v-if="config.gateway == 'paytm'"
                    label="Paytm Key*"
                    :rules="rules.required"
                    v-model="config.paytm_key"
                  ></v-text-field>
                  <v-switch
                    v-model="config.testing"
                    color="primary"
                    class="v-input--reverse"
                    style="justify-content:start;"
                    hide-details
                  >
                    <template slot="label">
                      Testing
                    </template>
                  </v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            small
            outline
            @click.native="
              dialog1 = false;
              resetForm();
            "
            >Close</v-btn
          >
          <v-btn
            color="primary darken-1 white--text"
            small
            :disabled="!valid1"
            @click.native="updateConfig()"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" max-width="400px">
      <v-card>
        <v-card-title class="red--text">
          <h3>Warning !!</h3>
        </v-card-title>
        <v-card-text>
          Error: Something went wrong... Please try again.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="blue" flat @click="dialog2 = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script type="text/javascript">
import api from '@/api';
export default {
  data() {
    return {
      search: '',
      vendors: [],
      headers: [],
      selected: [],
      dialog: false,
      rules: {
        required: [v => /^(?!\s*$).+/.test(v) || 'Field is required'],
      },
      config: {
        vendor_id: '',
        gateway: '',
        rzp_account_id: '',
        rzp_key: '',
        rzp_secret: '',
        paytm_mid: '',
        paytm_key: '',
        testing: false,
      },
      dialog2: false,
      dialog1: false,
      valid: false,
      valid1: false,
      confirm: false,
    };
  },
  methods: {
    loadConfig() {
      let loader = this.$loading.show();
      api
        .get('vendors/settings/payment')
        .then(r => {
          this.vendors = r.data;
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.loadConfig();
            }
          }
        });
    },
    addConfig() {
      if (this.valid) {
        let loader = this.$loading.show();
        api
          .post('vendors/settings/payment', this.config)
          .then(r => {
            loader.hide();
            this.loadConfig();
            this.dialog = false;
            this.resetForm();
          })
          .catch(err => {
            loader.hide();
            this.dialog2 = true;
          });
      }
    },
    editConfig() {
      this.config = this.selected[0];
      this.dialog1 = true;
    },
    updateConfig() {
      if (this.valid1) {
        let loader = this.$loading.show();
        const { id, ...data } = this.config;
        api
          .put('vendors/settings/payment/' + id, data)
          .then(r => {
            loader.hide();
            this.loadConfig();
            this.dialog1 = false;
            this.resetForm();
          })
          .catch(err => {
            loader.hide();
            this.dialog2 = true;
          });
      }
    },
    update(config) {
      let loader = this.$loading.show();
      const { id, ...data } = config;
      api
        .put('vendors/settings/payment/' + id, data)
        .then(r => {
          loader.hide();
          this.loadConfig();
          this.dialog1 = false;
          this.resetForm();
        })
        .catch(err => {
          loader.hide();
          this.dialog2 = true;
        });
    },
    deleteConfig(e) {
      this.confirm = false;
      let loader = this.$loading.show();
      api
        .delete('vendors/settings/payment/' + this.selected[0].id)
        .then(r => {
          loader.hide();
          this.loadConfig();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.deleteConfig(e);
            }
          }
        });
    },
    resetForm() {
      this.config = {
        vendor_id: '',
        gateway: '',
        rzp_account_id: '',
        rzp_key: '',
        rzp_secret: '',
        paytm_key: '',
        testing: false,
      };
    },
    vendorName(p) {
      return this.$store.state.vendors.find(v => v.id == p).app_name;
    },
  },
  created() {
    api
      .get('vendors/settings/payment')
      .then(r => {
        this.vendors = r.data;
      })
      .catch(async err => {
        if (err.message == 'Network Error') {
          const res = await this.$dialog.confirm({
            text: 'Please check your internet connection and try again',
            title: 'Connection Failed',
            actions: [
              { text: 'Cancel', color: 'primary', key: false },
              { text: 'Retry', color: 'primary', key: true },
            ],
          });
          if (res) {
            this.loadConfig();
          }
        }
      });
    this.headers = [
      {
        sortable: false,
        text: 'Id',
        value: 'id',
      },
      {
        sortable: false,
        text: 'Vendor Name',
        value: 'name',
      },
      {
        sortable: false,
        text: 'Gateway',
      },
      {
        sortable: false,
        text: 'Razorpay Account Id',
        align: 'center',
      },
      {
        sortable: false,
        text: 'Razorpay Key',
        align: 'center',
      },
      {
        sortable: false,
        text: 'Razorpay Secret',
        align: 'center',
      },
      {
        sortable: false,
        text: 'Paytm Mid',
      },
      {
        sortable: false,
        text: 'Paytm Key',
      },
      {
        sortable: false,
        text: 'Testing',
      },
    ];
  },
};
</script>
